import { API, API_BASE } from '../config/api';
import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';


// Get or create a persistent fan ID
function getFanId() {
  let id = localStorage.getItem('melodrop_fan_id');
  if (!id) {
    id = 'fan_' + Math.random().toString(36).substring(2) + Date.now().toString(36);
    localStorage.setItem('melodrop_fan_id', id);
  }
  return id;
}

export default function LikeButton({ itemType, itemId, size = 'sm' }) {
  const [liked, setLiked] = useState(false);
  const [count, setCount] = useState(0);
  const [animating, setAnimating] = useState(false);

  const fanId = getFanId();

  useEffect(() => {
    axios.get(`${API}/likes/${itemType}/${itemId}?fan_id=${fanId}&reaction_type=heart`)
      .then(r => { setLiked(r.data.liked); setCount(r.data.count); })
      .catch(() => {});
  }, [itemType, itemId, fanId]);

  const toggle = useCallback(async (e) => {
    e.stopPropagation();
    e.preventDefault();
    setAnimating(true);
    const newLiked = !liked;
    setLiked(newLiked);
    setCount(prev => newLiked ? prev + 1 : Math.max(0, prev - 1));
    try {
      const { data } = await axios.post(`${API}/likes`, { item_type: itemType, item_id: itemId, fan_id: fanId, reaction_type: 'heart' });
      setLiked(data.liked);
      setCount(data.count);
    } catch {
      setLiked(!newLiked);
      setCount(prev => newLiked ? Math.max(0, prev - 1) : prev + 1);
    }
    setTimeout(() => setAnimating(false), 600);
  }, [liked, itemType, itemId, fanId]);

  const iconSize = size === 'lg' ? 'w-6 h-6' : size === 'md' ? 'w-5 h-5' : 'w-4 h-4';
  const textSize = size === 'lg' ? 'text-sm' : 'text-xs';

  return (
    <button
      onClick={toggle}
      className={`group flex items-center gap-1.5 transition-all duration-300 ${liked ? 'text-[#FF3B30]' : 'text-[#666] hover:text-[#FF3B30]/70'}`}
      data-testid={`like-btn-${itemType}-${itemId}`}
      title={liked ? 'Unlike' : 'Like'}
    >
      <span className={`relative ${iconSize} ${animating ? 'like-pulse' : ''}`}>
        {liked ? (
          <svg viewBox="0 0 24 24" fill="currentColor" className="w-full h-full drop-shadow-[0_0_6px_rgba(255,59,48,0.5)]">
            <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>
          </svg>
        ) : (
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="w-full h-full">
            <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>
            <line x1="4" y1="4" x2="20" y2="20" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" opacity="0.4"/>
          </svg>
        )}
      </span>
      {count > 0 && <span className={`${textSize} font-mono font-bold`}>{count}</span>}

      <style>{`
        @keyframes likePulse {
          0% { transform: scale(1); }
          25% { transform: scale(1.4); }
          50% { transform: scale(0.9); }
          75% { transform: scale(1.15); }
          100% { transform: scale(1); }
        }
        .like-pulse { animation: likePulse 0.5s ease-out; }
      `}</style>
    </button>
  );
}

export { getFanId };
